import { defineStore } from "pinia";
import { computed, ref, Ref } from "vue";
import { useStorage } from "@vueuse/core";
import { ClientDTO } from "@/repositories/dto/client/ClientDTO.ts";

export const useClientStore = defineStore("client", () => {
  const currentClientUuid: Ref<string | null> = useStorage("currentClientUuid", null);
  const clients: Ref<ClientDTO[]> = ref([]);
  const currentClient: Ref<ClientDTO | null> = computed(() => {
    if (currentClientUuid.value) {
      for (const i in clients.value) {
        const client = clients.value[i];
        if (client.id === currentClientUuid.value) {
          return client;
        }
      }
    }
    return null;
  });

  function setClients(clients: ClientDTO[]) {
    this.clients.value = clients;
  }

  function setCurrentClientUuid(uuid: string | null) {
    currentClientUuid.value = uuid;
  }

  return {
    clients,
    currentClient,
    currentClientUuid,
    setClients,
    setCurrentClientUuid
  };
});

export default useClientStore;
